"use client";

import styles from "@/styles/modules/components/contact/ModuleFaqsFaq.module.scss";
import { useState } from "react";

interface ModuleFaqsFaq {
  fkey: number;
  title: string;
  text: string;
}

export default function ModuleFaqsFaq({ fkey, title, text }: ModuleFaqsFaq) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div data-k={fkey} className={`${styles.faq} ${isOpen ? styles.opened : ""}`}>
      <h4 onClick={() => setIsOpen(!isOpen)} data-aos="fadeIn" data-aos-delay={100 * fkey}>{title}</h4>
      <p>{text}</p>
    </div>
  );
}
